// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminConfigurationsPage_TenantInformationFragment = { __typename?: 'TenantInformation', id: string, workosOrganizationId?: string | null };

export type AdminConfigurationsPage_TenantSsoConnectionFragment = { __typename?: 'TenantSSOConnection', id: string, jitEnabledAt?: Time | null, ssoConnection: { __typename?: 'SSOConnection', id: string, displayName: string, boundEmailDomains: Array<string>, isLuminary: boolean } };

export type AdminConfigurationsPage_IntegrationConfigurationFragment = { __typename?: 'IntegrationConfiguration', id: string, enableLlmByok: boolean, snowflakeDataSharingDatabase?: string | null, snowflakeDataSharingRole?: string | null, snowflakeIntegrationDisplayName?: string | null };

export type AdminConfigurationsPage_TenantSecurityConfigurationFragment = { __typename?: 'TenantSecurityConfiguration', id: string, luminaryAccessControlEnabled?: boolean | null };

export type AdminConfigurationsPage_TenantFragment = { __typename?: 'Tenant', id: string, workosDirectoryID?: string | null, workosOauthClientID?: string | null, workosM2mClientID?: string | null, orgMembershipType?: Types.TenantOrgMembershipType | null, luminaryOrganization?: { __typename?: 'LuminaryOrganization', id: string } | null };

export type AdminConfigurationsPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminConfigurationsPageQuery = { __typename?: 'Query', tenantInformation: (
    { __typename?: 'TenantInformation' }
    & AdminConfigurationsPage_TenantInformationFragment
  ), integrationConfiguration?: (
    { __typename?: 'IntegrationConfiguration' }
    & AdminConfigurationsPage_IntegrationConfigurationFragment
  ) | null, tenantSecurityConfiguration?: (
    { __typename?: 'TenantSecurityConfiguration' }
    & AdminConfigurationsPage_TenantSecurityConfigurationFragment
  ) | null, tenantSSOConnections: { __typename?: 'TenantSSOConnectionConnection', edges?: Array<{ __typename?: 'TenantSSOConnectionEdge', node?: (
        { __typename?: 'TenantSSOConnection' }
        & AdminConfigurationsPage_TenantSsoConnectionFragment
      ) | null } | null> | null } };

export type AdminConfigurationsPageTenantQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AdminConfigurationsPageTenantQuery = { __typename?: 'Query', node?: { __typename?: 'AISuggestion' } | { __typename?: 'AISuggestionEvidence' } | { __typename?: 'AccessAgeParameter' } | { __typename?: 'AccessParameter' } | { __typename?: 'Account' } | { __typename?: 'ActiveEstateInsightsPage' } | { __typename?: 'Activity' } | { __typename?: 'Address' } | { __typename?: 'Answer' } | { __typename?: 'AnswerEvidence' } | { __typename?: 'AnswerRevision' } | { __typename?: 'Approval' } | { __typename?: 'AssetClass' } | { __typename?: 'AssetGroup' } | { __typename?: 'AssetStatic' } | { __typename?: 'AssetV2' } | { __typename?: 'AssetValuationV2' } | { __typename?: 'AssetValueV2' } | { __typename?: 'AsyncJob' } | { __typename?: 'BalanceSheetBundleConfiguration' } | { __typename?: 'BalanceSheetCategory' } | { __typename?: 'BalanceSheetViewConfiguration' } | { __typename?: 'BeneficiariesBundleConfiguration' } | { __typename?: 'BeneficiariesTemplateBundleConfiguration' } | { __typename?: 'Beneficiary' } | { __typename?: 'BeneficiaryAccessParameter' } | { __typename?: 'BeneficiaryDesignationGroup' } | { __typename?: 'BeneficiaryDistribution' } | { __typename?: 'BeneficiaryDistributionParameter' } | { __typename?: 'BeneficiaryPage' } | { __typename?: 'BeneficiaryPowerOfAppointment' } | { __typename?: 'CCorpBusinessEntity' } | { __typename?: 'CLTProposal' } | { __typename?: 'CLTTrust' } | { __typename?: 'CRTProposal' } | { __typename?: 'CRTTrust' } | { __typename?: 'Capability' } | { __typename?: 'Cashflow' } | { __typename?: 'ClientOrganization' } | { __typename?: 'ClientPresentationV2' } | { __typename?: 'ClientProfile' } | { __typename?: 'ClientProfileRelationship' } | { __typename?: 'Collaborator' } | { __typename?: 'ComparedWaterfall' } | { __typename?: 'CompletedEstateInsightsPage' } | { __typename?: 'ControllingParty' } | { __typename?: 'Conversation' } | { __typename?: 'CoverPageConfiguration' } | { __typename?: 'CustodialPersonalAccount' } | { __typename?: 'DSUEPortability' } | { __typename?: 'DiagramArtifact' } | { __typename?: 'DiagramArtifactPrompt' } | { __typename?: 'DispositionScenario' } | { __typename?: 'DispositiveProvision' } | { __typename?: 'DispositiveProvisionTemplate' } | { __typename?: 'DividerBundleConfiguration' } | { __typename?: 'DividerTemplateBundleConfiguration' } | { __typename?: 'Document' } | { __typename?: 'DocumentQuestion' } | { __typename?: 'DocumentQuestionAnswers' } | { __typename?: 'DocumentSummary' } | { __typename?: 'DocumentSummaryPage' } | { __typename?: 'DocumentSummaryPrompt' } | { __typename?: 'DocumentSummaryPromptTestRun' } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename?: 'DonorAdvisedFund' } | { __typename?: 'Employee' } | { __typename?: 'EntitiesOverviewBundleConfiguration' } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity' } | { __typename?: 'Entity' } | { __typename?: 'EntityDiagram' } | { __typename?: 'EntityDocumentRelationship' } | { __typename?: 'EntityGraphView' } | { __typename?: 'EntityGraphViewBundleConfiguration' } | { __typename?: 'EntityNotes' } | { __typename?: 'EntityProposal' } | { __typename?: 'EntitySummaryBundleConfiguration' } | { __typename?: 'EntitySummaryTemplateBundleConfiguration' } | { __typename?: 'EntityTask' } | { __typename?: 'EntityTaxInfo' } | { __typename?: 'EstateInsight' } | { __typename?: 'EstateInsightReference' } | { __typename?: 'EstateInsightsBundleConfiguration' } | { __typename?: 'EstateTaxScenario' } | { __typename?: 'EstateWaterfall' } | { __typename?: 'EstateWaterfallHypotheticalStateChange' } | { __typename?: 'EstateWaterfallHypotheticalTransfer' } | { __typename?: 'EstateWaterfallMessageContext' } | { __typename?: 'EstateWaterfallVisualizationConfig' } | { __typename?: 'EstateWaterfallVisualizationFilter' } | { __typename?: 'FamilyTreeBundleConfiguration' } | { __typename?: 'FamilyTreeConfiguration' } | { __typename?: 'FeatureFlag' } | { __typename?: 'FeatureFlagQueryRule' } | { __typename?: 'File' } | { __typename?: 'FilePage' } | { __typename?: 'FileParagraph' } | { __typename?: 'Form' } | { __typename?: 'FormVersion' } | { __typename?: 'GPBusinessEntity' } | { __typename?: 'GRATAnnuityV2' } | { __typename?: 'GRATProposalScenario' } | { __typename?: 'GRATTrust' } | { __typename?: 'GiftingProposal' } | { __typename?: 'GiftingProposalCashFlow' } | { __typename?: 'GiftingProposalGift' } | { __typename?: 'GiftingProposalGiftSender' } | { __typename?: 'GiftingProposalPortfolio' } | { __typename?: 'GiftingProposalScenario' } | { __typename?: 'GraphVisualizationGroup' } | { __typename?: 'GrowthProfile' } | { __typename?: 'GrowthProfileOverride' } | { __typename?: 'Household' } | { __typename?: 'HypotheticalCLT' } | { __typename?: 'HypotheticalCRT' } | { __typename?: 'HypotheticalGRAT' } | { __typename?: 'HypotheticalInsurance' } | { __typename?: 'HypotheticalSaleLoan' } | { __typename?: 'HypotheticalTransferAsset' } | { __typename?: 'HypotheticalTransferFundingSource' } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename?: 'ILITCrummeyLetter' } | { __typename?: 'ILITTrust' } | { __typename?: 'Image' } | { __typename?: 'IncomeTaxPaymentConfig' } | { __typename?: 'IndividualPersonalAccount' } | { __typename?: 'InferredField' } | { __typename?: 'InferredFieldEvidence' } | { __typename?: 'InsightsTemplateBundleConfiguration' } | { __typename?: 'InsurancePersonalAccount' } | { __typename?: 'InsurancePolicy' } | { __typename?: 'InsurancePremiumPayment' } | { __typename?: 'IntegrationAssetClass' } | { __typename?: 'IntegrationCashflow' } | { __typename?: 'IntegrationClient' } | { __typename?: 'IntegrationConfiguration' } | { __typename?: 'IntegrationEntity' } | { __typename?: 'IntegrationInsurance' } | { __typename?: 'IntegrationLiability' } | { __typename?: 'IntegrationPerson' } | { __typename?: 'IrrevocableTrust' } | { __typename?: 'JointPersonalAccount' } | { __typename?: 'KGNode' } | { __typename?: 'KGRelationship' } | { __typename?: 'KGRoot' } | { __typename?: 'KGV2Document' } | { __typename?: 'KGV2DocumentChange' } | { __typename?: 'KGV2DocumentModification' } | { __typename?: 'KGV2Graph' } | { __typename?: 'KGV2Node' } | { __typename?: 'KGV2NodeAlias' } | { __typename?: 'KGV2NodeEvidence' } | { __typename?: 'KGV2Statement' } | { __typename?: 'KGV2StatementEvidence' } | { __typename?: 'KGV2StatementSupersession' } | { __typename?: 'KeyPerson' } | { __typename?: 'KeyPersonRole' } | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | { __typename?: 'LiabilitiesBundleConfiguration' } | { __typename?: 'Liability' } | { __typename?: 'LiabilityPayment' } | { __typename?: 'LifeInsuranceBundleConfiguration' } | { __typename?: 'LifetimeExclusionEvent' } | { __typename?: 'LoggedTransfer' } | { __typename?: 'LuminaryOrganization' } | { __typename?: 'LuminaryTenantJIT' } | { __typename?: 'ManagedSFTPConnection' } | { __typename?: 'Memo' } | { __typename?: 'MemoPrompt' } | { __typename?: 'Message' } | { __typename?: 'MissingDocumentOverride' } | { __typename?: 'MissingDocumentsPage' } | { __typename?: 'ModelMapping' } | { __typename?: 'NotificationApp' } | { __typename?: 'NotificationPreference' } | { __typename?: 'OpenaiSdkConfig' } | { __typename?: 'OrganizationApplicationConfiguration' } | { __typename?: 'OrganizationDisclaimerConfiguration' } | { __typename?: 'OwnershipStake' } | { __typename?: 'PlatformDocument' } | { __typename?: 'PlatformFile' } | { __typename?: 'PlatformFilePage' } | { __typename?: 'PlatformFileParagraph' } | { __typename?: 'PresentationApprovalRequest' } | { __typename?: 'PresentationAssetDistributionBundleConfiguration' } | { __typename?: 'PresentationAssetDistributionItemConfiguration' } | { __typename?: 'PresentationAssetDistributionItemDetail' } | { __typename?: 'PresentationBundle' } | { __typename?: 'PresentationBundleCoverPage' } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename?: 'PresentationBusinessOverviewItem' } | { __typename?: 'PresentationCoverPage' } | { __typename?: 'PresentationCoverSlideConfig' } | { __typename?: 'PresentationCustomPage' } | { __typename?: 'PresentationCustomPageBundleConfiguration' } | { __typename?: 'PresentationDiagramPage' } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename?: 'PresentationDocumentsReviewedDocument' } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveItem' } | { __typename?: 'PresentationItemCitation' } | { __typename?: 'PresentationPage' } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename?: 'PresentationPlanningOpportunitiesItem' } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyItem' } | { __typename?: 'PresentationTemplate' } | { __typename?: 'PresentationTemplateBundle' } | { __typename?: 'PresentationTemplateCoverPage' } | { __typename?: 'PresentationTemplateCustomPage' } | { __typename?: 'PresentationTemplateDiagramPage' } | { __typename?: 'PresentationTemplatePage' } | { __typename?: 'PresentationTrustOverviewBundleConfiguration' } | { __typename?: 'PresentationTrustOverviewItem' } | { __typename?: 'PresentationTrustOverviewTrustConfiguration' } | { __typename?: 'PresentationWillBundleConfiguration' } | { __typename?: 'PresentationWillClientConfiguration' } | { __typename?: 'PresentationWillItem' } | { __typename?: 'Principal' } | { __typename?: 'PrivateFoundation' } | { __typename?: 'ProfessionalTeamRole' } | { __typename?: 'Proposal' } | { __typename?: 'ProposalScenario' } | { __typename?: 'QPRTTrust' } | { __typename?: 'QualifiedTuitionPersonalAccount' } | { __typename?: 'ReleaseGroup' } | { __typename?: 'ReminderEmailNotificationRecord' } | { __typename?: 'RetirementPersonalAccount' } | { __typename?: 'RevocableTrust' } | { __typename?: 'Role' } | { __typename?: 'SCorpBusinessEntity' } | { __typename?: 'SLATTrust' } | { __typename?: 'SSOConnection' } | { __typename?: 'SalesforceExportAttempt' } | { __typename?: 'ScheduledDistribution' } | { __typename?: 'SoleProprietorshipBusinessEntity' } | { __typename?: 'SubBrand' } | { __typename?: 'SubBrandDisclaimerConfiguration' } | { __typename?: 'Submission' } | { __typename?: 'TaxDragConfig' } | { __typename?: 'TaxDragOverride' } | { __typename?: 'Team' } | (
    { __typename?: 'Tenant' }
    & AdminConfigurationsPage_TenantFragment
  ) | { __typename?: 'TenantApplicationConfiguration' } | { __typename?: 'TenantBranding' } | { __typename?: 'TenantDisclaimerConfiguration' } | { __typename?: 'TenantDocument' } | { __typename?: 'TenantReminderEmailsConfiguration' } | { __typename?: 'TenantSSOConnection' } | { __typename?: 'TenantSecurityConfiguration' } | { __typename?: 'TenantSlideConfig' } | { __typename?: 'TestCMKEncryption' } | { __typename?: 'TestamentaryEntity' } | { __typename?: 'TrustAdvisor' } | { __typename?: 'TrustAdvisorRole' } | { __typename?: 'Trustee' } | { __typename?: 'TrusteeDuty' } | { __typename?: 'User' } | { __typename?: 'UserFeedback' } | { __typename?: 'UserNotificationConfiguration' } | { __typename?: 'WaterfallBundleConfiguration' } | { __typename?: 'WaterfallBundleCoverPage' } | { __typename?: 'WaterfallComparisonBundleConfiguration' } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename?: 'WaterfallTemplateBundleConfiguration' } | { __typename?: 'WorkOSOrganization' } | { __typename?: 'WorkOSOrganizationDomain' } | { __typename?: 'WorkflowTracker' } | null };

export type CreateSsoConnectionFromAdminMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateSsoConnectionInput;
}>;


export type CreateSsoConnectionFromAdminMutation = { __typename?: 'Mutation', createSSOConnection: { __typename?: 'SSOConnection', id: string, displayName: string, boundEmailDomains: Array<string>, workosOrganizationID: string } };

export type CreateTenantSsoConnectionFromAdminMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateTenantSsoConnectionInput;
}>;


export type CreateTenantSsoConnectionFromAdminMutation = { __typename?: 'Mutation', createTenantSSOConnection: { __typename?: 'TenantSSOConnection', id: string, jitEnabledAt?: Time | null, ssoConnection: { __typename?: 'SSOConnection', id: string, displayName: string, boundEmailDomains: Array<string>, workosOrganizationID: string } } };

export type UpdateSsoConnectionFromAdminMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateSsoConnectionInput;
}>;


export type UpdateSsoConnectionFromAdminMutation = { __typename?: 'Mutation', updateSSOConnection: { __typename?: 'SSOConnection', id: string, displayName: string, boundEmailDomains: Array<string> } };

export type UpdateTenantSsoConnectionFromAdminMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateTenantSsoConnectionInput;
}>;


export type UpdateTenantSsoConnectionFromAdminMutation = { __typename?: 'Mutation', updateTenantSSOConnection: { __typename?: 'TenantSSOConnection', id: string, jitEnabledAt?: Time | null } };

export type UpdateTenantFromAdminMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateTenantInput;
}>;


export type UpdateTenantFromAdminMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'Tenant', id: string, name: string, workosDirectoryID?: string | null, workosUpdatedAt?: Time | null, workosOauthClientID?: string | null, workosM2mClientID?: string | null } };

export type UpdateIntegrationConfigurationFromAdminMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateIntegrationConfigurationInput;
}>;


export type UpdateIntegrationConfigurationFromAdminMutation = { __typename?: 'Mutation', updateIntegrationConfiguration?: { __typename?: 'IntegrationConfiguration', id: string, enableLlmByok: boolean } | null };

export type UpdateTenantSecurityConfigurationFromAdminMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateTenantSecurityConfigurationInput;
}>;


export type UpdateTenantSecurityConfigurationFromAdminMutation = { __typename?: 'Mutation', updateTenantSecurityConfiguration?: { __typename?: 'TenantSecurityConfiguration', id: string, luminaryAccessControlEnabled?: boolean | null } | null };

export const Operations = {
  Query: {
    AdminConfigurationsPage: 'AdminConfigurationsPage' as const,
    AdminConfigurationsPageTenant: 'AdminConfigurationsPageTenant' as const
  },
  Mutation: {
    CreateSSOConnectionFromAdmin: 'CreateSSOConnectionFromAdmin' as const,
    CreateTenantSSOConnectionFromAdmin: 'CreateTenantSSOConnectionFromAdmin' as const,
    UpdateSSOConnectionFromAdmin: 'UpdateSSOConnectionFromAdmin' as const,
    UpdateTenantSSOConnectionFromAdmin: 'UpdateTenantSSOConnectionFromAdmin' as const,
    UpdateTenantFromAdmin: 'UpdateTenantFromAdmin' as const,
    UpdateIntegrationConfigurationFromAdmin: 'UpdateIntegrationConfigurationFromAdmin' as const,
    UpdateTenantSecurityConfigurationFromAdmin: 'UpdateTenantSecurityConfigurationFromAdmin' as const
  },
  Fragment: {
    AdminConfigurationsPage_TenantInformation: 'AdminConfigurationsPage_TenantInformation' as const,
    AdminConfigurationsPage_TenantSSOConnection: 'AdminConfigurationsPage_TenantSSOConnection' as const,
    AdminConfigurationsPage_IntegrationConfiguration: 'AdminConfigurationsPage_IntegrationConfiguration' as const,
    AdminConfigurationsPage_TenantSecurityConfiguration: 'AdminConfigurationsPage_TenantSecurityConfiguration' as const,
    AdminConfigurationsPage_Tenant: 'AdminConfigurationsPage_Tenant' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AdminConfigurationsPage_TenantInformationFragmentDoc = gql`
    fragment AdminConfigurationsPage_TenantInformation on TenantInformation {
  id
  workosOrganizationId
}
    `;
export const AdminConfigurationsPage_TenantSsoConnectionFragmentDoc = gql`
    fragment AdminConfigurationsPage_TenantSSOConnection on TenantSSOConnection {
  id
  jitEnabledAt
  ssoConnection {
    id
    displayName
    boundEmailDomains
    isLuminary
  }
}
    `;
export const AdminConfigurationsPage_IntegrationConfigurationFragmentDoc = gql`
    fragment AdminConfigurationsPage_IntegrationConfiguration on IntegrationConfiguration {
  id
  enableLlmByok
  snowflakeDataSharingDatabase
  snowflakeDataSharingRole
  snowflakeIntegrationDisplayName
}
    `;
export const AdminConfigurationsPage_TenantSecurityConfigurationFragmentDoc = gql`
    fragment AdminConfigurationsPage_TenantSecurityConfiguration on TenantSecurityConfiguration {
  id
  luminaryAccessControlEnabled
}
    `;
export const AdminConfigurationsPage_TenantFragmentDoc = gql`
    fragment AdminConfigurationsPage_Tenant on Tenant {
  id
  workosDirectoryID
  workosOauthClientID
  workosM2mClientID
  luminaryOrganization {
    id
  }
  orgMembershipType
}
    `;
export const AdminConfigurationsPageDocument = gql`
    query AdminConfigurationsPage {
  tenantInformation {
    ...AdminConfigurationsPage_TenantInformation
  }
  integrationConfiguration {
    ...AdminConfigurationsPage_IntegrationConfiguration
  }
  tenantSecurityConfiguration {
    ...AdminConfigurationsPage_TenantSecurityConfiguration
  }
  tenantSSOConnections {
    edges {
      node {
        ...AdminConfigurationsPage_TenantSSOConnection
      }
    }
  }
}
    ${AdminConfigurationsPage_TenantInformationFragmentDoc}
${AdminConfigurationsPage_IntegrationConfigurationFragmentDoc}
${AdminConfigurationsPage_TenantSecurityConfigurationFragmentDoc}
${AdminConfigurationsPage_TenantSsoConnectionFragmentDoc}`;

/**
 * __useAdminConfigurationsPageQuery__
 *
 * To run a query within a React component, call `useAdminConfigurationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminConfigurationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminConfigurationsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminConfigurationsPageQuery(baseOptions?: Apollo.QueryHookOptions<AdminConfigurationsPageQuery, AdminConfigurationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminConfigurationsPageQuery, AdminConfigurationsPageQueryVariables>(AdminConfigurationsPageDocument, withFetchPolicyContext(options));
      }
export function useAdminConfigurationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminConfigurationsPageQuery, AdminConfigurationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminConfigurationsPageQuery, AdminConfigurationsPageQueryVariables>(AdminConfigurationsPageDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useAdminConfigurationsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminConfigurationsPageQuery, AdminConfigurationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminConfigurationsPageQuery, AdminConfigurationsPageQueryVariables>(AdminConfigurationsPageDocument, withFetchPolicyContext(options));
        }
export type AdminConfigurationsPageQueryHookResult = ReturnType<typeof useAdminConfigurationsPageQuery>;
export type AdminConfigurationsPageLazyQueryHookResult = ReturnType<typeof useAdminConfigurationsPageLazyQuery>;
export type AdminConfigurationsPageSuspenseQueryHookResult = ReturnType<typeof useAdminConfigurationsPageSuspenseQuery>;
export type AdminConfigurationsPageQueryResult = Apollo.QueryResult<AdminConfigurationsPageQuery, AdminConfigurationsPageQueryVariables>;
export const AdminConfigurationsPageTenantDocument = gql`
    query AdminConfigurationsPageTenant($id: ID!) {
  node(id: $id) {
    ... on Tenant {
      ...AdminConfigurationsPage_Tenant
    }
  }
}
    ${AdminConfigurationsPage_TenantFragmentDoc}`;

/**
 * __useAdminConfigurationsPageTenantQuery__
 *
 * To run a query within a React component, call `useAdminConfigurationsPageTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminConfigurationsPageTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminConfigurationsPageTenantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminConfigurationsPageTenantQuery(baseOptions: Apollo.QueryHookOptions<AdminConfigurationsPageTenantQuery, AdminConfigurationsPageTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminConfigurationsPageTenantQuery, AdminConfigurationsPageTenantQueryVariables>(AdminConfigurationsPageTenantDocument, withFetchPolicyContext(options));
      }
export function useAdminConfigurationsPageTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminConfigurationsPageTenantQuery, AdminConfigurationsPageTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminConfigurationsPageTenantQuery, AdminConfigurationsPageTenantQueryVariables>(AdminConfigurationsPageTenantDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useAdminConfigurationsPageTenantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminConfigurationsPageTenantQuery, AdminConfigurationsPageTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminConfigurationsPageTenantQuery, AdminConfigurationsPageTenantQueryVariables>(AdminConfigurationsPageTenantDocument, withFetchPolicyContext(options));
        }
export type AdminConfigurationsPageTenantQueryHookResult = ReturnType<typeof useAdminConfigurationsPageTenantQuery>;
export type AdminConfigurationsPageTenantLazyQueryHookResult = ReturnType<typeof useAdminConfigurationsPageTenantLazyQuery>;
export type AdminConfigurationsPageTenantSuspenseQueryHookResult = ReturnType<typeof useAdminConfigurationsPageTenantSuspenseQuery>;
export type AdminConfigurationsPageTenantQueryResult = Apollo.QueryResult<AdminConfigurationsPageTenantQuery, AdminConfigurationsPageTenantQueryVariables>;
export const CreateSsoConnectionFromAdminDocument = gql`
    mutation CreateSSOConnectionFromAdmin($input: AugmentedCreateSSOConnectionInput!) {
  createSSOConnection(input: $input) {
    id
    displayName
    boundEmailDomains
    workosOrganizationID
  }
}
    `;
export type CreateSsoConnectionFromAdminMutationFn = Apollo.MutationFunction<CreateSsoConnectionFromAdminMutation, CreateSsoConnectionFromAdminMutationVariables>;

/**
 * __useCreateSsoConnectionFromAdminMutation__
 *
 * To run a mutation, you first call `useCreateSsoConnectionFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSsoConnectionFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSsoConnectionFromAdminMutation, { data, loading, error }] = useCreateSsoConnectionFromAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSsoConnectionFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateSsoConnectionFromAdminMutation, CreateSsoConnectionFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSsoConnectionFromAdminMutation, CreateSsoConnectionFromAdminMutationVariables>(CreateSsoConnectionFromAdminDocument, options);
      }
export type CreateSsoConnectionFromAdminMutationHookResult = ReturnType<typeof useCreateSsoConnectionFromAdminMutation>;
export type CreateSsoConnectionFromAdminMutationResult = Apollo.MutationResult<CreateSsoConnectionFromAdminMutation>;
export type CreateSsoConnectionFromAdminMutationOptions = Apollo.BaseMutationOptions<CreateSsoConnectionFromAdminMutation, CreateSsoConnectionFromAdminMutationVariables>;
export const CreateTenantSsoConnectionFromAdminDocument = gql`
    mutation CreateTenantSSOConnectionFromAdmin($input: AugmentedCreateTenantSSOConnectionInput!) {
  createTenantSSOConnection(input: $input) {
    id
    jitEnabledAt
    ssoConnection {
      id
      displayName
      boundEmailDomains
      workosOrganizationID
    }
  }
}
    `;
export type CreateTenantSsoConnectionFromAdminMutationFn = Apollo.MutationFunction<CreateTenantSsoConnectionFromAdminMutation, CreateTenantSsoConnectionFromAdminMutationVariables>;

/**
 * __useCreateTenantSsoConnectionFromAdminMutation__
 *
 * To run a mutation, you first call `useCreateTenantSsoConnectionFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantSsoConnectionFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantSsoConnectionFromAdminMutation, { data, loading, error }] = useCreateTenantSsoConnectionFromAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTenantSsoConnectionFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantSsoConnectionFromAdminMutation, CreateTenantSsoConnectionFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantSsoConnectionFromAdminMutation, CreateTenantSsoConnectionFromAdminMutationVariables>(CreateTenantSsoConnectionFromAdminDocument, options);
      }
export type CreateTenantSsoConnectionFromAdminMutationHookResult = ReturnType<typeof useCreateTenantSsoConnectionFromAdminMutation>;
export type CreateTenantSsoConnectionFromAdminMutationResult = Apollo.MutationResult<CreateTenantSsoConnectionFromAdminMutation>;
export type CreateTenantSsoConnectionFromAdminMutationOptions = Apollo.BaseMutationOptions<CreateTenantSsoConnectionFromAdminMutation, CreateTenantSsoConnectionFromAdminMutationVariables>;
export const UpdateSsoConnectionFromAdminDocument = gql`
    mutation UpdateSSOConnectionFromAdmin($input: AugmentedUpdateSSOConnectionInput!) {
  updateSSOConnection(input: $input) {
    id
    displayName
    boundEmailDomains
  }
}
    `;
export type UpdateSsoConnectionFromAdminMutationFn = Apollo.MutationFunction<UpdateSsoConnectionFromAdminMutation, UpdateSsoConnectionFromAdminMutationVariables>;

/**
 * __useUpdateSsoConnectionFromAdminMutation__
 *
 * To run a mutation, you first call `useUpdateSsoConnectionFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSsoConnectionFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSsoConnectionFromAdminMutation, { data, loading, error }] = useUpdateSsoConnectionFromAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSsoConnectionFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSsoConnectionFromAdminMutation, UpdateSsoConnectionFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSsoConnectionFromAdminMutation, UpdateSsoConnectionFromAdminMutationVariables>(UpdateSsoConnectionFromAdminDocument, options);
      }
export type UpdateSsoConnectionFromAdminMutationHookResult = ReturnType<typeof useUpdateSsoConnectionFromAdminMutation>;
export type UpdateSsoConnectionFromAdminMutationResult = Apollo.MutationResult<UpdateSsoConnectionFromAdminMutation>;
export type UpdateSsoConnectionFromAdminMutationOptions = Apollo.BaseMutationOptions<UpdateSsoConnectionFromAdminMutation, UpdateSsoConnectionFromAdminMutationVariables>;
export const UpdateTenantSsoConnectionFromAdminDocument = gql`
    mutation UpdateTenantSSOConnectionFromAdmin($input: AugmentedUpdateTenantSSOConnectionInput!) {
  updateTenantSSOConnection(input: $input) {
    id
    jitEnabledAt
  }
}
    `;
export type UpdateTenantSsoConnectionFromAdminMutationFn = Apollo.MutationFunction<UpdateTenantSsoConnectionFromAdminMutation, UpdateTenantSsoConnectionFromAdminMutationVariables>;

/**
 * __useUpdateTenantSsoConnectionFromAdminMutation__
 *
 * To run a mutation, you first call `useUpdateTenantSsoConnectionFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantSsoConnectionFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantSsoConnectionFromAdminMutation, { data, loading, error }] = useUpdateTenantSsoConnectionFromAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantSsoConnectionFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantSsoConnectionFromAdminMutation, UpdateTenantSsoConnectionFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantSsoConnectionFromAdminMutation, UpdateTenantSsoConnectionFromAdminMutationVariables>(UpdateTenantSsoConnectionFromAdminDocument, options);
      }
export type UpdateTenantSsoConnectionFromAdminMutationHookResult = ReturnType<typeof useUpdateTenantSsoConnectionFromAdminMutation>;
export type UpdateTenantSsoConnectionFromAdminMutationResult = Apollo.MutationResult<UpdateTenantSsoConnectionFromAdminMutation>;
export type UpdateTenantSsoConnectionFromAdminMutationOptions = Apollo.BaseMutationOptions<UpdateTenantSsoConnectionFromAdminMutation, UpdateTenantSsoConnectionFromAdminMutationVariables>;
export const UpdateTenantFromAdminDocument = gql`
    mutation UpdateTenantFromAdmin($input: AugmentedUpdateTenantInput!) {
  updateTenant(input: $input) {
    id
    name
    workosDirectoryID
    workosUpdatedAt
    workosOauthClientID
    workosM2mClientID
  }
}
    `;
export type UpdateTenantFromAdminMutationFn = Apollo.MutationFunction<UpdateTenantFromAdminMutation, UpdateTenantFromAdminMutationVariables>;

/**
 * __useUpdateTenantFromAdminMutation__
 *
 * To run a mutation, you first call `useUpdateTenantFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantFromAdminMutation, { data, loading, error }] = useUpdateTenantFromAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantFromAdminMutation, UpdateTenantFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantFromAdminMutation, UpdateTenantFromAdminMutationVariables>(UpdateTenantFromAdminDocument, options);
      }
export type UpdateTenantFromAdminMutationHookResult = ReturnType<typeof useUpdateTenantFromAdminMutation>;
export type UpdateTenantFromAdminMutationResult = Apollo.MutationResult<UpdateTenantFromAdminMutation>;
export type UpdateTenantFromAdminMutationOptions = Apollo.BaseMutationOptions<UpdateTenantFromAdminMutation, UpdateTenantFromAdminMutationVariables>;
export const UpdateIntegrationConfigurationFromAdminDocument = gql`
    mutation UpdateIntegrationConfigurationFromAdmin($input: AugmentedUpdateIntegrationConfigurationInput!) {
  updateIntegrationConfiguration(input: $input) {
    id
    enableLlmByok
  }
}
    `;
export type UpdateIntegrationConfigurationFromAdminMutationFn = Apollo.MutationFunction<UpdateIntegrationConfigurationFromAdminMutation, UpdateIntegrationConfigurationFromAdminMutationVariables>;

/**
 * __useUpdateIntegrationConfigurationFromAdminMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationConfigurationFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationConfigurationFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationConfigurationFromAdminMutation, { data, loading, error }] = useUpdateIntegrationConfigurationFromAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationConfigurationFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationConfigurationFromAdminMutation, UpdateIntegrationConfigurationFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationConfigurationFromAdminMutation, UpdateIntegrationConfigurationFromAdminMutationVariables>(UpdateIntegrationConfigurationFromAdminDocument, options);
      }
export type UpdateIntegrationConfigurationFromAdminMutationHookResult = ReturnType<typeof useUpdateIntegrationConfigurationFromAdminMutation>;
export type UpdateIntegrationConfigurationFromAdminMutationResult = Apollo.MutationResult<UpdateIntegrationConfigurationFromAdminMutation>;
export type UpdateIntegrationConfigurationFromAdminMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationConfigurationFromAdminMutation, UpdateIntegrationConfigurationFromAdminMutationVariables>;
export const UpdateTenantSecurityConfigurationFromAdminDocument = gql`
    mutation UpdateTenantSecurityConfigurationFromAdmin($input: AugmentedUpdateTenantSecurityConfigurationInput!) {
  updateTenantSecurityConfiguration(input: $input) {
    id
    luminaryAccessControlEnabled
  }
}
    `;
export type UpdateTenantSecurityConfigurationFromAdminMutationFn = Apollo.MutationFunction<UpdateTenantSecurityConfigurationFromAdminMutation, UpdateTenantSecurityConfigurationFromAdminMutationVariables>;

/**
 * __useUpdateTenantSecurityConfigurationFromAdminMutation__
 *
 * To run a mutation, you first call `useUpdateTenantSecurityConfigurationFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantSecurityConfigurationFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantSecurityConfigurationFromAdminMutation, { data, loading, error }] = useUpdateTenantSecurityConfigurationFromAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantSecurityConfigurationFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantSecurityConfigurationFromAdminMutation, UpdateTenantSecurityConfigurationFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantSecurityConfigurationFromAdminMutation, UpdateTenantSecurityConfigurationFromAdminMutationVariables>(UpdateTenantSecurityConfigurationFromAdminDocument, options);
      }
export type UpdateTenantSecurityConfigurationFromAdminMutationHookResult = ReturnType<typeof useUpdateTenantSecurityConfigurationFromAdminMutation>;
export type UpdateTenantSecurityConfigurationFromAdminMutationResult = Apollo.MutationResult<UpdateTenantSecurityConfigurationFromAdminMutation>;
export type UpdateTenantSecurityConfigurationFromAdminMutationOptions = Apollo.BaseMutationOptions<UpdateTenantSecurityConfigurationFromAdminMutation, UpdateTenantSecurityConfigurationFromAdminMutationVariables>;